var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplyAllLine = function SvgReplyAllLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.3 5.25V9.3a9 9 0 0 1 8.971 9.729 8.1 8.1 0 0 0-6.89-4.325L16.1 14.7h-1.8v4.05L7.1 12zm-5.4 0v2.463L4.328 12l4.571 4.285.001 2.465L1.7 12zm3.6 4.154L9.732 12l2.768 2.595V12.9h3.63l.313.006a9.9 9.9 0 0 1 3.308.69A7.19 7.19 0 0 0 14.3 11.1h-1.8z"
  })));
};
export default SvgReplyAllLine;